import React from 'react';
import FormCheckBoxGroup from './components/FormCheckBoxGroup';
import FormDateOnly from './components/FormDateOnly';
import FormInput from './components/FormInput';
import FormInputTextArea from './components/FormInputTextArea';
import RadioButtonGroup from './components/FormRadioButtonGroup';
import FormSwitch from './components/FormSwitch';
import FormTime from './components/FormTime';
import MultiSelect from './components/MultiSelect';

export default function DynamicFormField({ dynamicField, form }) {
  const { title, type, fieldProps = {}, adminRequired, html, htmlUnder } = dynamicField;

  fieldProps.formContext = form;
  fieldProps.form = form;
  if (!fieldProps.formFieldOptions) fieldProps.formFieldOptions = {};
  fieldProps.formFieldOptions.required = adminRequired;
  fieldProps.html = html;
  fieldProps.htmlUnder = htmlUnder;
  switch (type) {
    case 'header': {
      return <h3>{title}</h3>;
    }
    case 'text':
    case 'email':
    case 'phone':
    case 'integer':
    case 'number': {
      if (type === 'integer' && fieldProps.minLength && fieldProps.maxLength) {
        return (
          <FormInput
            {...fieldProps}
            type={type}
            expectedMaxLength={fieldProps.maxLength}
            expectedMinLength={fieldProps.minLength}
            sx={{
              '& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              '& input[type=number]::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              '& input[type=number]': {
                MozAppearance: 'textfield',
              },
            }}
          />
        );
      }
      return <FormInput {...fieldProps} type={type} />;
    }
    case 'checkbox': {
      return <FormCheckBoxGroup {...fieldProps} />;
    }
    case 'textarea': {
      return <FormInputTextArea {...fieldProps} />;
    }
    case 'date': {
      return <FormDateOnly {...fieldProps} />;
    }
    case 'switch': {
      return <FormSwitch switchLabel={title} {...fieldProps} />;
    }
    case 'radio': {
      return <RadioButtonGroup {...fieldProps} />;
    }
    case 'time': {
      return <FormTime {...fieldProps} />;
    }

    case 'select': {
      if (Array.isArray(fieldProps.defaultValue))
        fieldProps.defaultValue = fieldProps.defaultValue[0];
      return (
        <MultiSelect
          isSingleSelect
          labelKey="label"
          placeholder={'Select'}
          valueKey="value"
          findValueInOptions
          {...fieldProps}
        />
      );
    }
    default: {
      return null;
    }
  }
}
